<template>
  <ppt-slide-viewer module-code="xsq_jm2" />
</template>

<script>
import PptSlideViewer from "@/components/PptSlideViewer.vue";

export default {
  name: "XsqJm2",
  components: { PptSlideViewer }
};
</script>
